// Standard resume download used across the app.
// Downloads the resume as "<candidateName>'s Resume.<original extension>".
// Uses fetch->blob so the custom file name is honored even for cross-origin
// (S3) links; falls back to a direct link if the fetch is ever CORS-blocked.
export async function downloadResumeFile(link, candidateName) {
  if (!link) return;
  const extension = getFileExtensionFromUrl(link);
  const fileName = `${candidateName}'s Resume${
    extension ? "." + extension : ""
  }`;
  try {
    const response = await fetch(link);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    // Cross-origin fetch blocked: fall back to a direct download. The browser
    // will use the server's Content-Disposition name in this case.
    const a = document.createElement("a");
    a.href = link;
    a.download = fileName;
    a.click();
  }
}

function getFileExtensionFromUrl(url) {
  const name = url.substring(url.lastIndexOf("/") + 1).split("?")[0];
  return name.includes(".") ? name.split(".").pop().toLowerCase() : "";
}

export function downloadFeedback(url) {
  if (url) {
    // Create a temporary link element
    const link = document.createElement("a");
    link.href = url;
    link.download = "proposed_file_name"; // Set the desired file name
    link.style.display = "none"; // Make the link invisible

    // Append the link to the body
    document.body.appendChild(link);

    // Trigger a click on the link
    link.click();

    // Remove the link from the DOM after triggering the click
    document.body.removeChild(link);
  }
}
